var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.19954 42.5C4.96811 42.5 2.95371 38.9651 4.56943 36.1499L20.3699 8.61142C21.9856 5.79619 26.0144 5.79619 27.6301 8.61142L43.4306 36.1499C45.0463 38.9651 43.0319 42.5 39.8005 42.5H8.19954Z",
    fill: "#F25467"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 33.5C26.5 34.8807 25.3807 36 24 36C22.6193 36 21.5 34.8807 21.5 33.5C21.5 32.1193 22.6193 31 24 31C25.3807 31 26.5 32.1193 26.5 33.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 18.5V26.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.aa0b6df5a50b62766d6765985ed33766.svg";
export { ForwardRef as ReactComponent };